import {registerWithoutHeaders as registerRequestAPI} from './register-request-api';

export  default {
    registerRequestAPI,
};